import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";
import { SetStateAction } from "react";
import { fieldsPersonItemTitles } from "../../../data/admin";
import { getPrefix } from "../../../utils/getPrefix";

export const fieldInfoModal = ({
  t,
  saveFieldInfo,
  windowValues,
  setWindowValues,
  modalData,
  closeMsg,
}: stdObject) => {
  return {
    title: windowValues.FIEPER,
    mainColor: modalData.mainColor,
    blocked: true,
    inputs: fieldsPersonItemTitles
      .filter((e: stdObject) => e.code !== "FIEPER")
      .map((e: stdObject) => {
        return {
          label:
            e.code === "ORDPER" ? t(`p.order`) : t(`c.${getPrefix(e.code)}`),
          value: windowValues[e.code],
          type: e.code === "ORDPER" ? "integer" : "checkbox",
          innerStyle: { width: 70 },
          onChange: (o: { target: { value: SetStateAction<string> } }) =>
            setWindowValues({
              ...windowValues,
              [e.code]:
                e.code === "ORDPER"
                  ? o.target.value
                  : Number(o.target.value)
                    ? 0
                    : 1,
            }),
        };
      }),
    buttons: [
      {
        label: t("p.save"),
        onClick: saveFieldInfo,
        color: colors.green,
      },
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
